<template>
  <div style='height: 100%;'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-set' class='navbarbtn' v-if='showSetProducetItemIDPower'
        @click='showSetProducetItemIDDialogMD'>
        设置专用产品号
      </el-button>

      <el-button type='primary' icon='sys sys-print' class='navbarbtn' v-if='showPrintPower'
        @click='print(1)'>
        补打标签
      </el-button>

      <el-button type='primary' icon='sys sys-print' class='navbarbtn' v-if='showPrintPower'
        @click='printPM(1)'>
        补打标签(生产)
      </el-button>

      <el-button type='primary' icon='sys sys-print' class='navbarbtn' v-if='showPrintPower'
        @click='print(0)'>
        仅补打内箱标签
      </el-button>

      <el-button type='primary' icon='sys sys-print' class='navbarbtn' v-if='showPrintPower'
        @click='print(2)'>
        仅补打外箱标签
      </el-button>

      <el-button type='warning' icon='wms wms-chaifen' class='navbarbtn' v-if='showSpitOuterQRCodePower'
        @click='outerQRCodeSplit()'>
        外箱拆分
      </el-button>

      <el-button type='warning' icon='wms wms-stockplace' class='navbarbtn' v-if='showMergeOuterQRCodePower'
        @click='outerQRCodeMerge()'>
        外箱合并
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>
    </div>

    <!-- 行展开收起    :expandRowKeys='mainTable.expandRowKeys' -->
    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :row-style='mainTableRowStyle'
      :reduceHeight='200' :seqFixed='true'
      :showDefaultExpandColumn='true' :showExpandColumn='false'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      :showOperationsColumn='true' operationColumnWidth='60px'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='拆分' placement='top-start'
          v-if='showCfPower && (scope.data.row.Status === "1" || scope.data.row.Status === "7")'>
          <el-button type='primary' circle style='padding: 4px;' @click='showCFDialogMD(scope.data.row)'><i class='sys sys-split'></i></el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='撤销拆分' placement='top-start'
          v-if='showCancelCfPower && scope.data.row.CFFlag === "1"'>
          <el-button type='danger' circle style='padding: 4px;' @click='cancelCF(scope.data.row)'><i class='sys sys-split'></i></el-button>
        </el-tooltip>
      </template>
    </Table>

    <el-dialog v-dialogDrag title='设置专用产品号' :visible.sync='showSetProducetItemIDDialog' width='340px'
      top='10px' lock-scroll>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 80px; text-align: left'>
          专用产品号
        </div>
        <el-input class='inputField-input' v-model='producetItemID'
          size='mini' style='width: 200px;'>
        </el-input>
      </div>
      <div class='dialogButtomCenterBtn' style='margin-top: 40px;'>
        <el-button type='primary' @click='showSetProducetItemID()' size='mini'>设置</el-button>
        <el-button @click='showSetProducetItemIDDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='标签拆分' :visible.sync='showCFDialog' width='330px'
      top='10px' lock-scroll>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          拆分数量
        </div>
        <el-input-number class='inputField-input' v-model='cfQty'
          size='mini' style='width: 200px;'>
        </el-input-number>
      </div>
      <div class='dialogButtomCenterBtn' style='margin-top: 40px;'>
        <el-button type='primary' @click='cf()' size='mini'>拆分</el-button>
        <el-button @click='showCFDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'

export default {
  name: 'QRCodeSearch',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'WMS_QRCode',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      showSetProducetItemIDDialog: false,
      producetItemID: '',

      showCFDialog: false,
      cfQty: 0,
      cfQRCode: '',
      cfRow: {},

      showCancelPower: false,
      showDeletePower: false,
      showBatchCancelPower: false,
      showBatchDeletePower: false,
      showPrintPower: false,
      showSetProducetItemIDPower: false,
      showCfPower: false,
      showCancelCfPower: false,
      showSpitOuterQRCodePower: false,
      showMergeOuterQRCodePower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Status === '9') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '2') {
        return { 'background-color': 'lightblue' }
      } else if (data.row.Status === '1') {
        return { 'background-color': 'lightgreen' }
      } else if (data.row.Status === '7') {
        return { 'background-color': 'orange' }
      } else if (data.row.Status === '8') {
        return { 'background-color': 'Violet' }
      } else if (data.row.Status === 'S') {
        return { 'background-color': 'Pink' }
      } else {
        return {}
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 打印
    print: function (printouter) {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const qrcodesAry = []
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        qrcodesAry.push(that.mainTable.selections[i].QRCode)
        if (that.mainTable.Status === '9') {
          that.$message.error('请选择未作废的标签！')
          return
        }
      }
      if (printouter === 1) {
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=0&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=QRCode.rpt', 'QRCode')
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=2&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=OuterQRCode.rpt', 'OuterQRCode')
      } else if (printouter === 0) {
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=0&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=QRCode.rpt', 'QRCode')
      } else if (printouter === 2) {
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=2&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=OuterQRCode.rpt', 'OuterQRCode')
      }
      that.refreshMainTableContent()
    },

    // 打印（生产）
    printPM: function (printouter) {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const qrcodesAry = []
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        qrcodesAry.push(that.mainTable.selections[i].QRCode)
        if (that.mainTable.Status === '9') {
          that.$message.error('请选择未作废的标签！')
          return
        }
      }
      if (printouter === 1) {
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=0&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=PMQRCode.rpt', 'QRCode')
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=2&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=PMOuterQRCode.rpt', 'OuterQRCode')
      } else if (printouter === 0) {
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=0&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=PMQRCode.rpt', 'QRCode')
      } else if (printouter === 2) {
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=2&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=PMOuterQRCode.rpt', 'OuterQRCode')
      }
      that.refreshMainTableContent()
    },

    // 设置专用产品号弹出框显示方法
    showSetProducetItemIDDialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      that.showSetProducetItemIDDialog = true
      that.producetItemID = ''
    },

    // 设置专用产品号
    showSetProducetItemID: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.SetProducetItemID', {
        rows: that.mainTable.selections,
        producetItemID: that.producetItemID
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('设置成功！')
        that.showSetProducetItemIDDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 拆分弹出框显示方法
    showCFDialogMD: function (row) {
      const that = this
      that.showCFDialog = true
      that.cfQty = 0
      that.cfQRCode = row.QRCode
      that.cfRow = row
    },

    // 拆分
    cf: async function () {
      const that = this
      if (that.cfQty <= 0) {
        that.$message.error('拆分数量必须大于0！')
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.CFQRCode', {
        row: that.cfRow,
        cfQty: that.cfQty
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('拆分成功！')
        that.showCFDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    cancelCF: function (row) {
      const that = this
      that.$confirm('此操作将撤销该标签的拆分操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.CancelCFQRCode', {
          row: row
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('撤销拆分成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 外箱拆分
    outerQRCodeSplit: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const outerQRCode = that.mainTable.selections[0].OuterQRCode
      for (const i in that.mainTable.selections) {
        if (that.mainTable.selections[i].OuterQRCode !== outerQRCode) {
          that.$message.error('请选择相同外箱标签的内箱标签拆分！')
          return
        }
      }
      that.$confirm('此操作将永久拆分这些标签吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.CFOuterQRCode', {
          rows: that.mainTable.selections
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('外箱拆分成功！新增外箱编号【' + rtnObj.msg + '】')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 外箱合并
    outerQRCodeMerge: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const itemID = that.mainTable.selections[0].ItemID
      const batchNo = that.mainTable.selections[0].BatchNo
      const kfDate = that.mainTable.selections[0].KFDate
      const kfPeriod = that.mainTable.selections[0].KFPeriod
      for (const i in that.mainTable.selections) {
        if (that.mainTable.selections[i].ItemID !== itemID) {
          that.$message.error('请选择相同物料的内箱标签合并！')
          return
        }
        if (that.mainTable.selections[i].BatchNo !== batchNo) {
          that.$message.error('请选择相同批号的内箱标签合并！')
          return
        }
        if (that.mainTable.selections[i].KFDate !== kfDate) {
          that.$message.error('请选择相同生产日期的内箱标签合并！')
          return
        }
        if (that.mainTable.selections[i].KFPeriod !== kfPeriod) {
          that.$message.error('请选择相同保质期的内箱标签合并！')
          return
        }
      }
      that.$confirm('此操作将永久合并这些标签吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.HBOuterQRCode', {
          rows: that.mainTable.selections
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('外箱合并成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
